import { render, staticRenderFns } from "./ProgramAuthManager.vue?vue&type=template&id=052e9b36"
import script from "./ProgramAuthManager.vue?vue&type=script&lang=js"
export * from "./ProgramAuthManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports